<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {};
</script> 

<style lang="scss">
#app > .md-layout {
    min-height: 100vh;
}

.siv-vertical-layout {
    display: flex;
    justify-content: center;
    margin: auto;
    border-radius: 10px;
}

.md-overlay{
    z-index:0 !important;
    background: none !important;
}

@media screen and (max-width: 480px) {
  .siv-vertical-layout {
      min-width: 100vw;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .siv-vertical-layout {
      min-width: 100vw;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {

}

@media screen and (min-width: 1025px) {

}

</style>